module.exports = __webpack_public_path__ + "static/media/grid2.42e6903c.jpg";